"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _dateFns = require("date-fns");
var _imageSrc = require("../../lib/imageSrc");
var _lodash = require("lodash");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var AuthorInfo = props => {
  var numOfAuthors = props.fields.Author.length;
  if (numOfAuthors === 0) {
    return null;
  } else if (numOfAuthors === 1) {
    var author = props.fields.Author[0];
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "mm-media-object reverse mm-spacing"
    }, /*#__PURE__*/_react.default.createElement("picture", {
      className: "mm-img-circle--lg"
    }, !(0, _lodash.isEmpty)(author.fields.Thumbnail.value) && /*#__PURE__*/_react.default.createElement("img", {
      src: (0, _imageSrc.imageHref)(author.fields.Thumbnail.value),
      alt: author.fields.Thumbnail.value.alt
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "body"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "eyebrow"
    }, /*#__PURE__*/_react.default.createElement("p", null, "Posted on ", (0, _dateFns.format)(new Date(props.fields.Date.value), 'MMMM dd, yyyy'))), /*#__PURE__*/_react.default.createElement("div", {
      className: "copy-lg"
    }, /*#__PURE__*/_react.default.createElement("h4", null, "By:\xA0 ", !(0, _lodash.isEmpty)(author.fields.Name.value) && !(0, _lodash.isEmpty)(author.fields.Credentials.value) && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("a", {
      "data-bp-link": "default",
      href: author.url.toLowerCase()
    }, author.fields.Name.value, " ", author.fields.Credentials.value)), !(0, _lodash.isEmpty)(author.fields.Name.value) && (0, _lodash.isEmpty)(author.fields.Credentials.value) && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("a", {
      "data-bp-link": "default",
      href: author.url.toLowerCase()
    }, author.fields.Name.value)))), !(0, _lodash.isEmpty)(author.fields.Bio.value) && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, author.fields.Bio.value)));
  } else {
    var authors = props.fields.Author.map(function (author, index) {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
        key: index
      }, index > 0 && index !== numOfAuthors - 1 && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, ",\xA0"), index === numOfAuthors - 1 && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "\xA0and\xA0"), /*#__PURE__*/_react.default.createElement("a", {
        key: index,
        "data-bp-link": "default",
        href: author.url.toLowerCase()
      }, author.fields.Name.value, " ", author.fields.Credentials.value));
    });
    var imageOverride = props.fields.AuthorImageOverride.value;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "mm-media-object reverse mm-spacing"
    }, /*#__PURE__*/_react.default.createElement("picture", {
      className: "mm-img-circle--lg"
    }, !(0, _lodash.isEmpty)(imageOverride) && /*#__PURE__*/_react.default.createElement("img", {
      src: (0, _imageSrc.imageHref)(imageOverride),
      alt: imageOverride.alt
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "body"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "eyebrow"
    }, /*#__PURE__*/_react.default.createElement("p", null, "Posted on ", (0, _dateFns.format)(new Date(props.fields.Date.value), 'MMMM dd, yyyy'))), /*#__PURE__*/_react.default.createElement("div", {
      className: "copy-lg"
    }, /*#__PURE__*/_react.default.createElement("h4", null, "By:\xA0 ", authors)), !(0, _lodash.isEmpty)(props.fields.AuthorBioOverride.value) && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, props.fields.AuthorBioOverride.value)));
  }
};
var _default = exports.default = AuthorInfo;